var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 22,
    height: 22,
    rx: 5,
    fill: "#41927F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 22,
    height: 22,
    rx: 5,
    stroke: "#41927F",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4738_17891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.362 16.594C10.2872 16.5914 10.2137 16.5737 10.146 16.5417C10.0783 16.5098 10.0179 16.4644 9.96833 16.4082L6.25405 12.694C6.18323 12.648 6.12377 12.5866 6.08015 12.5144C6.03654 12.4421 6.00991 12.3609 6.00228 12.2768C5.99465 12.1928 6.00622 12.1081 6.03611 12.0292C6.066 11.9502 6.11343 11.8791 6.17482 11.8212C6.23621 11.7633 6.30996 11.7201 6.3905 11.6948C6.47103 11.6696 6.55625 11.663 6.63972 11.6755C6.72319 11.688 6.80272 11.7193 6.87232 11.767C6.94192 11.8148 6.99976 11.8777 7.04147 11.9511L10.362 15.2494L18.1398 7.49396C18.2445 7.42607 18.3689 7.3953 18.4932 7.40658C18.6175 7.41786 18.7344 7.47054 18.8252 7.55618C18.916 7.64181 18.9753 7.75545 18.9938 7.87886C19.0123 8.00228 18.9889 8.12833 18.9272 8.23681L10.7558 16.4082C10.7062 16.4644 10.6458 16.5098 10.5781 16.5417C10.5104 16.5737 10.4369 16.5914 10.362 16.594Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4738_17891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5.5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.42cbc0d9eed24300fac044428cf772f7.svg";
export { ForwardRef as ReactComponent };